const locationsEndpoints = {
  countries: '/v1/countries',
  citiesByCountry: (countryId) => `/v1/countries/${countryId}/cities`,
  createCity: '/v1/cities'
};

export default locationsEndpoints;
